import SecureBaseModel from './SecureBaseModel';

class SessionModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static USERS_SESSION = 'users-session';
    static USERS_DETAILS = 'users-details';
    static USERS_VERIFY_ACCESS = 'users-verify-access';
    static USERS_SESSION_DETAILS = 'users-session-details';
    static USERS_SIGNIN_AS = 'users-signin-as';
    static USERS_AUTHORIZE_AUTH = 'users-authorize-auth';
    static USERS_EXPIRE = 'users-expire';

    constructor() {
        super();
    }

    async checkSession(params) {
        return await this.postData(SessionModel.USERS_SESSION, params);
    }

    async userDetails(params) {
        return await this.postData(SessionModel.USERS_DETAILS, params);
    }

    async verifyAccess(params) {
        return await this.postData(SessionModel.USERS_VERIFY_ACCESS, params);
    }

    async sessionDetails(params) {
        return await this.postData(SessionModel.USERS_SESSION_DETAILS, params);
    }

    async impersonateSession(params) {
        return await this.postData(SessionModel.USERS_SIGNIN_AS, params);
    }

    async authorizedUserAuth(params) {
        return await this.postData(SessionModel.USERS_AUTHORIZE_AUTH, params);
    }

    // Parameters: { userId: value, sessionId: value }
    async expire(params) {
        return await this.postData(SessionModel.USERS_EXPIRE, params);
    }
}

export default SessionModel;
